import * as moment from 'moment';

export class DateUtils {
  public static dateToString(date: Date, format: DateFormat): string {
    if (format === DateFormat.MMDDYYY) {
      return this.toMMDDYYY(date);
    }
    return null;
  }

  public static toMMDDYYY(date: Date): string {
    let mm = date.getMonth() + 1; // getMonth() is zero-based
    let dd = date.getDate();
    let yyyy = date.getFullYear();
    return mm.toString() + '/' + dd.toString() + '/' + yyyy.toString();
  }

  public static timeFromNow(date: Date): string {
    return moment(date).fromNow();
  }

  public static formatDate(date: any, dateFormat: any): any {
    return moment(date).format(dateFormat);
  }

  public static dateValidFormat(c: any): boolean {
    c = c.toString();
    if (c.pristine) {
      return true;
    }
    if (c !== undefined && c !== '' && c !== null) {
      let month = null;
      let day = null;
      let year = null;
      if (c.indexOf('/') > -1) {
        let res = c.split('/');
        if (res.length > 1) {
          month = res[0];
          day = res[1];
          year = res[2];
          if (year.length > 4) {
            return false;
          }
        }
      } else {
        if (c.length === 8) {
          // month = c.substring(0, 2);
          // day = c.substring(2, 4);
          // year = c.substring(4, 8);
          return false;
        }
      }
      if (isNaN(month) || isNaN(day) || isNaN(year)) {
        return false;
      }
      month = Number(month);
      day = Number(day);
      year = Number(year);
      if (month < 1 || month > 12) {
        // check month range
        return false;
      }
      if (day < 1 || day > 31) {
        return false;
      }
      if (
        (month === 4 || month === 6 || month === 9 || month === 11) &&
        day === 31
      ) {
        return false;
      }
      if (month === 2) {
        // check for february 29th
        let isleap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        if (day > 29 || (day === 29 && !isleap)) {
          return false;
        }
      }
      return true;
    }
  }
}

export enum DateFormat {
  MMDDYYY
}
